import React from "react";
import { ReactController } from "./react_controller";
import { FieldSchemaBuilder } from "../components/grids/FieldSchemaBuilder";
import { GregPrimerTheme } from "@getregistered/greg-editors";

export class FieldSchemaBuilderController extends ReactController {
  connect() {
    this.root.render(
      <GregPrimerTheme>
        <FieldSchemaBuilder {...this.propsValue} />
      </GregPrimerTheme>
    );
  }
}
